import { QrType } from "../types/types";

import { BiText, BiLinkAlt } from "react-icons/bi";
import { BsWhatsapp, BsFillChatLeftTextFill } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail, MdLocationOn, MdSignalWifi3Bar } from "react-icons/md";

export const isMobile = window.innerWidth < 768;

export let availableQrTypes: {
  id: QrType;
  label: string;
  icon: React.ReactNode;
  ignoreLabel?: boolean;
}[] = [
  { id: "url", label: "URL", icon: <BiLinkAlt /> },
  { id: "text", label: "Text", icon: <BiText /> },
  { id: "whatsapp", label: "Whatsapp", icon: <BsWhatsapp /> },
  { id: "sms", label: "SMS", icon: <BsFillChatLeftTextFill /> },
  { id: "phone", label: "Phone", icon: <FaPhoneAlt /> },
  { id: "email", label: "Email", icon: <MdEmail /> },
  { id: "location", label: "Location", icon: <MdLocationOn /> },
  { id: "wifi", label: "WiFi", icon: <MdSignalWifi3Bar /> },
  {
    id: "upi",
    label: "UPI",
    ignoreLabel: true,
    icon: (
      <img
        src="/assets/icons/upi.svg"
        style={{ width: "45px", height: "100%" }}
        alt="upi-icon"
      />
    ),
  },
];
